import { asyncRoutes } from "@/router";
import { getAuthor } from "@/api/user";

function hasPermission(roles, route) {
  if (route.meta && route.meta.roles && route.meta.roles.length) {
    let flag = false;
    route.meta.roles.forEach(role => {
      if (roles.includes(role)) {
        flag = true;
      }
    });
    return flag;
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, roles) {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes;
  },
};

const dealRouters = (author, path, routers) => {
  const newRouter = [];
  routers.forEach(async item => {
    if (item.children) {
      const concatPath = `${item.path != "/" ? `${item.path}/` : ""}`;
      item.children = await dealRouters(author, concatPath, item.children);
      if (item.children.length !== 0) {
        item.redirect = '/' + item.path + '/' + item.children[0].path;
        newRouter.push(item);
      }
    } else {
      const concatPath = `${path ? `/${path}` : ""}${item.path}`;
      if (concatPath === "index" || author.map(item => "/" + item).includes(concatPath)) {
        newRouter.push(item);
      }
    }
  });
  return newRouter;
};

const actions = {
  async generateRoutes({ commit }, roles) {
    const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
    const author = await getAuthor();
    console.log(author, 'author');
    // 处理路由
    author ? dealRouters(author.page, "", accessedRoutes) : dealRouters([], "", accessedRoutes);
    commit("SET_ROUTES", accessedRoutes);
    return accessedRoutes;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
